const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const COMPANY = {
  phone: "+357-22321316",
  mobile: "+357-99931264",
  whatsapp: "35799931264",
  email: "j.houseofsecretary@cytanet.com.cy",
  address: "Afroditis 10, Nicosia 1060, Cyprus",
  logo: "https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_300,w_300,f_auto,q_auto/20749311/510656_82382.png"
};

export { BACKEND_URL, API, COMPANY };
